import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.highRiskSupplementsSearch;
export const highRiskSupplementSearchSelector = (state: RootState) =>
  getState(state).data?.tableData || [];
export const highRiskSupplementSearchPageSelector = (state: RootState) =>
  getState(state).paginatedData?.tableData || [];
export const highRiskSupplementSearchPaginationSelector = (state: RootState) =>
  getState(state).data?.pagination;
export const highRiskSupplementSearchIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const highRiskSupplementSearchErrorSelector = (state: RootState) => getState(state).error;
export const highRiskSupplementSearchValueSelector = (state: RootState) =>
  getState(state).searchValue;
